import cleanString from "../cleanString";
import { create, all } from "mathjs";
const config = {};
const math2 = create(all, config);
import mathStringFunction from "./mathStringFunction";

export default function (av_ins) {
  if (av_ins) {
    const math_i = av_ins.math;
    const fields = av_ins.fields;
    if (math_i && math_i.length > 0) {
      let scope = {};
      math_i.forEach((e) => {
        const index = fields?.map((e) => e.title).indexOf(e.title);
        if (index !== -1) {
          // if (fields[index].input) {
          if (e.type !== "operator") {
            scope[cleanString(e.title.replaceAll(":", ""))] = fields[index]
              .input
              ? parseFloat(fields[index].input)
              : 0;
            // }
          }
        }
      });
      let r = 0;
      try {
        r = math2.evaluate(mathStringFunction(av_ins), scope);
      } catch (error) {
        console.log(error);
      }
      return r;
    }
  }
  return 0;
}
